/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var brandsConfig = {
  '18F': {
    id: '1001',
    code: '18F',
    fsOrgId: null,
    domain: '1800flowers',
    // brand's web domain - string in the middle of  https://www.1800flowers.com
    storeId: 20051,
    // brand's unique store ID
    catalogId: 13302,
    // brands have many catalogs,but web has one unique catalog
    description: '1-800-Flowers',
    // simple description of brand used for alt text
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#65388b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#f71548',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#65388b',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#1f1f1b',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#1f1f1b',
      orderConfirmationText: 'black',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#212121',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48, 69, 98, .85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      guidedNav: {
        background: '#FFF'
      },
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        background: '#fff',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#65388b',
      checkRadioBtn: '#65388b',
      copyright: '#606060',
      mobileFooterBottomLink: '#65388b',
      desktopBgFooter: '#65388b',
      modalBg: '#65388b',
      modalTile: '#65388b',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '15px'
    }
  },
  HD: {
    id: '1019',
    code: 'HD',
    fsOrgId: 'SCECX',
    domain: 'harryanddavid',
    storeId: 21051,
    catalogId: 16802,
    description: 'Harry & David',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabledContrast: '#1f1f1b',
      colorDisabled: '#ccc',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: 'white',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#2f2f2f',
      bigBoldLabel: '#595959',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      colorIconHeader: '#000',
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: 'black',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'none',
      linkMenu: '#595959',
      orderConfirmationHeader: '#595959',
      orderConfirmationText: 'black',
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      primary: {
        500: '#595959'
      },
      primaryButton: '#a1001a',
      productTitleColor: '#2f2f2f',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#595959',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#3c3c35',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#a1001a',
      copyright: '#747472',
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#909090'
      },
      mobileFooterBottomLink: '#747472',
      desktopBgFooter: '#f2f2f2',
      modalBg: '#f2f2f2',
      modalTile: '#f2f2f2',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#2f2f2f',
      // DEPRECATED
      cta2: '#a94',
      // DEPRECATED
      cta3: '#3c3c35',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#5b322c',
      // DEPRECATED
      brown2: '#311714',
      // DEPRECATED
      brown3: '#600600',
      // DEPRECATED
      brown4: '#d9d0c1',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // DEPRECATED
      brown6: '#ded8d8',
      // DEPRECATED
      grey1: '#2f2f2f',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#909090',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#e3e3e3',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#595959',
      // DEPRECATED
      grey11: '#e4e4e4',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: '14px'
    },
    excludeSEO: ['/gifthistory-home-gift-baskets', '/About-Us-Privacy-Policy', '/h/view/about01']
  },
  BRY: {
    id: '1029',
    code: 'BRY',
    fsOrgId: 'SCEYV',
    domain: 'berries',
    storeId: 25052,
    catalogId: 22303,
    description: 'Sharis Berries',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#D03E38',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#f71548',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#65388b',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#1f1f1b',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#1f1f1b',
      orderConfirmationText: 'black',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#212121',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48, 69, 98, .85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      guidedNav: {
        background: '#FFF'
      },
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        background: '#fff',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#65388b',
      checkRadioBtn: '#65388b',
      copyright: '#606060',
      mobileFooterBottomLink: '#65388b',
      desktopBgFooter: '#65388b',
      modalBg: '#65388b',
      modalTile: '#65388b',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '15px'
    }
  },
  '18B': {
    id: '1009',
    code: '18B',
    fsOrgId: 'SCG8B',
    domain: '1800baskets',
    storeId: 20054,
    catalogId: 13802,
    description: '1-800-Baskets',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#9c0352',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: 'white',
      bgPhoneIcon: '#1bc86d',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#9c0352',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#9c0352',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#ce046b',
      orderConfirmationHeader: '#9c0352',
      orderConfirmationText: 'black',
      primary: {
        500: '#9c0352'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      snipeText: 'white',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(206,4,107,0.7)',
      snipeTextFontSize: '12px',
      snipeTextFontWeight: 300,
      tickCheck: '#00CC33',
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#8E1429',
      checkRadioBtn: '#8E1429',
      copyright: '#000',
      mobileFooterBottomLink: '#000',
      desktopBgFooter: '#ececec',
      modalBg: '#ececec',
      modalTile: '#5b322c',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // this is weirdly named >> MenuItem.js class = toggleHeader
      cta1: '#9c0352',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '14px'
    },
    excludeSEO: ['About-Us-Privacy-Policy', 'About-Us-Terms-of-Use', 'passport-baskets', 'themarketboxlandingpage']
  },
  SCH: {
    id: '1025',
    code: 'SCH',
    fsOrgId: 'SCGK6',
    domain: 'simplychocolate',
    storeId: 24052,
    catalogId: 20803,
    description: 'Simply Chocolate',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#512c1d',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: 'white',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#512c1d',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#512c1d',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#272727',
      orderConfirmationHeader: '#512c1d',
      orderConfirmationText: 'black',
      primary: {
        500: '#512c1d'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#512c1d',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#512c1d',
      checkRadioBtn: '#512c1d',
      copyright: '#ffffff',
      mobileFooterBottomLink: '#ffffff',
      desktopBgFooter: '#512c1d',
      modalBg: '#ffffff',
      modalTile: '#1c0f0a',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#512c1d',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#600',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // this is weirdly named >> MenuItem.js class = toggleHeader
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED
      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica,Arial,sans-serif'
    },
    excludeSEO: ['/About-Us-Privacy-Policy', '/About-Us-Terms-of-Use']
  },
  FBQ: {
    id: '1010',
    code: 'FB',
    fsOrgId: 'SCG0J',
    domain: 'fruitbouquets',
    storeId: 20551,
    catalogId: 16302,
    description: 'Fruit Bouquets',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#F15A29',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      // DOES NOT PASS WCAG AA/AAA (with #FFF contrast,only fails WCAG AAA with #000),
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: 'white',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#F15A29',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#F15A29',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#F15A29',
      orderConfirmationText: 'black',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#F15A29',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      guidedNav: {
        background: '#FFF'
      },
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#F15A29',
      checkRadioBtn: '#F15A29',
      copyright: '#000',
      mobileFooterBottomLink: '#000',
      desktopBgFooter: '#ededeb',
      modalBg: '#ffffff',
      modalTile: '#9a0000',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#F15A29',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // this is weirdly named >> MenuItem.js class = toggleHeader
      pink1: '#8E1429',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica,Arial,sans-serif'
    }
  },
  CCO: {
    id: '1012',
    code: 'CCO',
    fsOrgId: 'SCENP',
    domain: 'cheryls',
    storeId: 10202,
    catalogId: 11102,
    description: "Cheryl's Cookies",
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#43201c',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: '#fff',
      bgPhoneIcon: '#1bc86d',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#43201c',
      bgTile2: '#ff0',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#43201c',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#43201c',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#43201c',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#43201c'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#43201c',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#43201c',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#43201c85',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#43201c',
        main: '#fff',
        product: '#fff',
        alternate: '#43201c',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#43201c',
        child: '#FAF6EA',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#e60a48',
      checkRadioBtn: '#e60a48',
      copyright: '#5b322c',
      mobileFooterBottomLink: '#5b322c',
      desktopBgFooter: '#fff',
      modalBg: '#ffffff',
      modalTile: '#600',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#43201c',
      cta2: '#a70e13',
      cta3: '#b31722',
      cta4: '#595959',
      pink1: '#e60a48',
      brown1: '#5b322c',
      brown2: '#311714',
      brown3: '#600600',
      brown4: '#d9d0c1',
      brown5: 'rgba(255,255,255,0.82)',
      brown6: '#ded8d8',
      grey1: '#1f1f1b',
      grey2: '#3c3c35',
      grey3: '#5c5c52',
      grey4: '#7c7c70',
      grey5: '#a8a89a',
      grey6: '#d1d1c1',
      grey7: '#e3e3e3',
      grey8: '#cccccc',
      grey9: '#e8eaec',
      grey10: '#b6b5b5',
      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '15px'
    }
  },
  PZU: {
    id: '1022',
    code: 'PZU',
    fsOrgId: 'SCHFX',
    domain: 'personalization-universe',
    storeId: 23052,
    catalogId: 20302,
    description: 'Personalization Universe',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#fff',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#f00'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#600',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#00CC33',
      checkRadioBtn: '#00CC33',
      copyright: '#000',
      mobileFooterBottomLink: '#000',
      desktopBgFooter: '#ededea',
      modalBg: '#ededea',
      modalTile: '#39c',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED
      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica,Arial,sans-serif'
    }
  },
  TPF: {
    id: '1002',
    code: 'TPF',
    fsOrgId: 'SCFPF',
    domain: 'thepopcornfactory',
    storeId: 10201,
    catalogId: 10101,
    description: 'The Popcorn Factory',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#900',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: 'white',
      bgPhoneIcon: '#1bc86d',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#43201c',
      bgTile2: '#ff0000',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#990000',
      colorIconHeader: '#990000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#990000',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#272727',
      orderConfirmationHeader: '#990000',
      orderConfirmationText: 'black',
      primary: {
        500: '#990000'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#990000',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#990000',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#99000085',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#990',
        main: '#fff',
        product: '#fff',
        alternate: '#990',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#990',
        child: '#fddbdb',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#e60a48',
      checkRadioBtn: '#e60a48',
      copyright: '#5b322c',
      mobileFooterBottomLink: '#5b322c',
      desktopBgFooter: '#ffffff',
      modalBg: '#ffffff',
      modalTile: '#000',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      pink1: '#e60a48',
      // DEPRECATED
      brown1: '#5b322c',
      // DEPRECATED
      brown2: '#311714',
      // DEPRECATED
      brown3: '#600600',
      // DEPRECATED
      brown4: '#d9d0c1',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // DEPRECATED
      brown6: '#ded8d8',
      // DEPRECATED
      cta1: '#990000',
      // DEPRECATED
      cta2: '#a70e13',
      // DEPRECATED
      cta3: '#b31722',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica,Arial,sans-serif'
    },
    excludeSEO: ['/About-Us-Terms-of-Use', '/About-Us-Privacy-Policy', '/shipping-information']
  },
  WLF: {
    id: '1020',
    code: 'WLF',
    fsOrgId: 'SCFA4',
    domain: 'wolfermans',
    storeId: 21551,
    catalogId: 17302,
    description: "Wolferman's",
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#3c3c35',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: 'white',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#324765'
      },
      primaryButton: '#a1001a',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#456',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#3c3c35',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#697e8d',
        main: '#fff',
        product: '#fff',
        alternate: '#697e8d',
        nonProduct: '#697e8d',
        // DEPRECATED- replaced by 'alternate'
        parent: '#364149',
        child: '#e8e8e8',
        leftMenuBG: '#697e8d'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#a1001a',
      copyright: '#1f1f1',
      mobileFooterBottomLink: '#1f1f1',
      desktopBgFooter: '#ffffff',
      modalBg: '#ffffff',
      modalTile: '#1f1f1b',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      pink1: '#8E1429',
      // DEPRECATED
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#595959',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: '14px'
    },
    excludeSEO: ['/w/sweepstakes-rules']
  },
  SY: {
    id: '1018',
    code: 'SY',
    fsOrgId: 'SCH4V',
    domain: 'stockyards',
    storeId: 22051,
    catalogId: 17802,
    description: 'Stock Yards',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#3c3c35',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#3c3c35',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: 'white',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#000',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#7c2529'
      },
      primaryButton: '#a1001a',
      productTitleColor: '#3c3c35',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#1f1f1b',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#3c3c35',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#3f3c3c',
        main: '#fff',
        product: '#fff',
        alternate: '#3f3c3c',
        nonProduct: '#3f3c3c',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#3f3c3c'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#a1001a',
      copyright: '#1f1f1b',
      mobileFooterBottomLink: '#1f1f1b',
      desktopBgFooter: '#f2f2f2',
      modalBg: '#f2f2f2',
      modalTile: '#1f1f1b',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#3c3c35',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#595959',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      fontSize: '14px'
    }
  },
  TM: {
    id: '',
    code: 'TM',
    fsOrgId: null,
    domain: 'themarket',
    storeId: 24552,
    catalogId: 21303,
    description: 'The Market',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#fff',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      giftMessageRadioButton: '#f50057',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#1bc86d',
      copyright: '#1f1f1b',
      mobileFooterBottomLink: '#1f1f1b',
      desktopBgFooter: '#f6f6f4',
      modalBg: '#ffffff',
      modalTile: '#20204f',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif'
    }
  },
  PML: {
    id: '1030',
    code: 'PML',
    fsOrgId: null,
    domain: 'personalizationmall',
    storeId: null,
    catalogId: null,
    description: 'Personalization Mall',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#ae201f',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#42434b',
      bgHeader: 'white',
      bgPhoneIcon: '#1bc86d',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#43201c',
      bgTile2: '#ff0000',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#990000',
      colorIconHeader: '#990000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      globalBannerBackgroundColor: '#990000',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#272727',
      orderConfirmationHeader: '#990000',
      orderConfirmationText: 'black',
      primary: {
        500: '#ae201f'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#990000',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#990000',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#99000085',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(255,255,255,0.82)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#990',
        main: '#fff',
        product: '#fff',
        alternate: '#990',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#990',
        child: '#fddbdb',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#e60a48',
      checkRadioBtn: '#e60a48',
      copyright: '#5b322c',
      mobileFooterBottomLink: '#5b322c',
      desktopBgFooter: '#ffffff',
      modalBg: '#ffffff',
      modalTile: '#000',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      pink1: '#e60a48',
      // DEPRECATED
      brown1: '#5b322c',
      // DEPRECATED
      brown2: '#311714',
      // DEPRECATED
      brown3: '#600600',
      // DEPRECATED
      brown4: '#d9d0c1',
      // DEPRECATED
      brown5: 'rgba(255,255,255,0.82)',
      // DEPRECATED
      brown6: '#ded8d8',
      // DEPRECATED
      cta1: '#990000',
      // DEPRECATED
      cta2: '#a70e13',
      // DEPRECATED
      cta3: '#b31722',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, sans-serif'
    },
    excludeSEO: []
  },
  VC: {
    id: '1031',
    code: 'VC',
    fsOrgId: null,
    domain: 'vitalchoice',
    storeId: 21051,
    // THIS IS NOT CORRECT!
    catalogId: 16802,
    // NOR IS THIS!!!
    description: 'Vital Choice',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#fff',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      giftMessageRadioButton: '#f50057',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#1bc86d',
      copyright: '#1f1f1b',
      mobileFooterBottomLink: '#1f1f1b',
      desktopBgFooter: '#f6f6f4',
      modalBg: '#ffffff',
      modalTile: '#20204f',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif'
    }
  },
  FL: {
    id: '1034',
    code: 'FL',
    fsOrgId: null,
    domain: 'florists',
    storeId: 20051,
    // THIS IS NOT CORRECT!
    catalogId: 13302,
    // NOR IS THIS!!!
    description: 'Florists',
    palette: {
      // replacement keys for clarity and versatility
      colorPrimary: '#1f1f1b',
      // replaces cta1
      colorPrimaryContrast: '#fff',
      colorSecondary: '#600',
      // replaces cta2
      colorSecondaryContrast: '#fff',
      colorTertiary: '#1f1f1b',
      // replaces cta3
      colorTertiaryContrast: '#fff',
      colorQuaternary: '#1f1f1b',
      // replaces cta4
      colorQuaternaryContrast: '#fff',
      colorQuinary: '#1f1f1b',
      // added for flexibility
      colorQuinaryContrast: '#fff',
      colorNeutral: '#1f1f1b',
      // replaces gray*
      colorNeutral10: '#fafafa',
      // begin alpha variants
      colorNeutral20: '#f5f5f5',
      colorNeutral30: '#eee',
      colorNeutral40: '#e0e0e0',
      colorNeutral50: '#bdbdbd',
      colorNeutral60: '#9e9e9e',
      colorNeutral70: '#757575',
      colorNeutral80: '#373737',
      colorNeutral90: '#1b1b1b',
      // end alpha variants

      colorInfo: '#1976d2',
      colorInfoContrast: '#fff',
      colorWarning: '#ffa000',
      colorWarningContrast: '#fff',
      colorAlert: '#a1001a',
      colorAlertContrast: '#fff',
      colorSuccess: '#43a047',
      colorSuccessContrast: '#fff',
      colorDisabled: '#ccc',
      colorDisabledContrast: '#1f1f1b',
      // existing acceptable values
      black: '#1f1f1b',
      white: '#fff',
      bgFooter: '#f2f2f2',
      bgHeader: '#fff',
      bgPhoneIcon: '#a1001a',
      bgPopup: 'rgba(0,0,0,.85)',
      bgSelected: 'rgba(48,69,98,.1)',
      bgTile1: '#a1001a',
      bgTile2: '#304562',
      bgTextOverlay1: 'rgba(0,0,0,0.6)',
      bigBoldLabel: '#5b322c',
      colorIconHeader: '#000',
      disableButton: '#d8d8d8',
      error: {
        main: '#ff0000'
      },
      gfBgColor: '#9872bb',
      gfMobileInputBorderBottom: '1px solid rgba(174,174,174,0.6)',
      gfMobileLabelTextColor: '#212121',
      gfMobileSelectOptionTextColor: '#606060',
      gfMobileZipInputLabelTextColor: '#a0a0a0',
      gfTabDesktopInputBorder: '1px solid #333',
      giftMessageRadioButton: '#f50057',
      globalBannerBackgroundColor: '#1f1f1b',
      globalBannerTextColor: 'white',
      globalBannerTextDecoration: 'underline',
      linkMenu: '#324765',
      orderConfirmationHeader: '#5b322c',
      orderConfirmationText: '#5b322c',
      primary: {
        500: '#324765'
      },
      primaryButton: '#1bc86d',
      productTitleColor: '#1f1f1b',
      sectionHeaderTextColor: '#202020',
      secondaryButton: '#324765',
      shape: {
        borderRadius: '4px'
      },
      tickCheck: '#00CC33',
      snipeText: '#660000',
      snipeTextPromo: '#a1001a',
      snipeTextBackground: 'rgba(48,69,98,.85)',
      snipeTextFontSize: '14px',
      snipeTextFontWeight: 500,
      promoGiftButtons: {
        background: '#e8eaec',
        color: '#2f2f2f'
      },
      globalBannerContainerBackground: '#ffffff',
      globalBannerContainerBorder: '#575757',
      globalBannerMainTextColor: '#2f2f2f',
      pdp: {
        subscription: {
          checkboxColor: '#3D70B2',
          rootContainerBackground: '#efdfb0',
          boxShadow: '0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)',
          overlayContainerBackground: '#fff',
          modalColor: '#fff',
          subTable: '#f7eed7',
          linkColor: '#304562',
          goButton: '#a1001a',
          goButtonColor: '#fff'
        }
      },
      mobileMenuBG: {
        header: '#909090',
        main: '#fff',
        product: '#fff',
        alternate: '#909090',
        nonProduct: '#909090',
        // DEPRECATED- replaced by 'alternate'
        parent: '#909090',
        child: '#e8e8e8',
        leftMenuBG: '#a8a89a'
      },
      desktopHeaderMenu: {
        // TODO: replace this with brand's real values
        background: '#f4f2f7',
        text: '#333',
        border: '1px solid #f5f5f5',
        maxWidth: '1400px'
      },
      uiShadow: '0 8px 4px -4px rgba(59,33,81,0.21)',
      unCheckRadioBtn: '#595959',
      checkRadioBtn: '#1bc86d',
      copyright: '#1f1f1b',
      mobileFooterBottomLink: '#1f1f1b',
      desktopBgFooter: '#f6f6f4',
      modalBg: '#ffffff',
      modalTile: '#20204f',
      // DEPRECATED - DO NOT USE/REFERENCE IN COMPONENTS ANY LONGER
      // OK to modify values as long as replacement is updated as well (unless specifically noted)
      cta1: '#1f1f1b',
      // DEPRECATED
      cta2: '#47201D',
      // DEPRECATED
      cta3: '#660000',
      // DEPRECATED
      cta4: '#595959',
      // DEPRECATED
      pink1: '#8E1429',
      // DEPRECATED
      brown1: '#47201D',
      // DEPRECATED
      brown2: '#DBD0C2',
      // DEPRECATED
      brown3: '#DBD0C2',
      // DEPRECATED
      grey1: '#1f1f1b',
      // DEPRECATED
      grey2: '#3c3c35',
      // DEPRECATED
      grey3: '#5c5c52',
      // DEPRECATED
      grey4: '#7c7c70',
      // DEPRECATED
      grey5: '#a8a89a',
      // DEPRECATED
      grey6: '#d1d1c1',
      // DEPRECATED
      grey7: '#ebebde',
      // DEPRECATED
      grey8: '#cccccc',
      // DEPRECATED
      grey9: '#e8eaec',
      // DEPRECATED
      grey10: '#b6b5b5',
      // DEPRECATED

      flowerGift: {
        topLogoText: {
          color: '#000000'
        },
        titleBg: {
          background: 'rgba(0, 0, 0, 0.1)'
        }
      },
      sympathyPage: {
        buttonColor: '#50396E',
        stickyBackground: '#fff',
        borderColors: '#ccc',
        containerWidth: '1400px'
      },
      myAccount: {
        contentGridBorder: '#7c7c7d',
        blockBorderRight: '#e2e2e2',
        blockMessageFadedInside: '#7c7c7d',
        blockHeaderbackground: '#ededea',
        blockActions: '#619ee6',
        caretSign: '#000',
        activeLink: '#000',
        divider: '#ccc',
        orderRow: '#f6f6f4',
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      },
      checkoutGuestForgotLinkColor: '#3b73af',
      checkout: {
        payment: {
          background: '#fff'
        }
      },
      tiers: {
        card: {
          backgroundColor: '#fff'
        },
        image: {
          maxWidth: '100%',
          height: 'auto'
        },
        title: {
          lineHeight: '42px',
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          upSmall: {
            textAlign: 'left'
          },
          downSmall: {
            textAlign: 'center'
          }
        },
        container: {
          backgroundColor: 'transparent',
          maxWidth: {
            downSmall: '100%',
            downMedium: '100%',
            upMedium: '970px',
            upLarge: '1170px'
          }
        }
      }
    },
    typography: {
      useNextVariants: true,
      fontFamily: 'Helvetica, Arial, sans-serif'
    }
  }
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Retrieve brand details via product ID.
 *
 * @param String brandId
 */
var getBrandById = function getBrandById(wcEnv, brandId) {
  return new Promise(function (resolve) {
    resolve(brandsConfig[brandId]);
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/**
 * Retrieve all brand details.
 *
 * @param String wcEnv
 */
var getAllBrands = function getAllBrands() {
  return new Promise(function (resolve) {
    resolve(brandsConfig);
  }).then(function (response) {
    return response;
  });
};

/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

var index = {
  getBrandById: getBrandById,
  getAllBrands: getAllBrands
};
export { index as default };